export const ROUTE_EMBED = "/embed"
export const ROUTE_RPC = "/rpc"
export const ROUTE_RPC_WALLETCONNECT = "/rpc/walletconnect"
